import zxcvbn from "zxcvbn";

const PASSWORD_STRENGTH_CHECKER_THRESHOLD = 100;
const passwordStrengthExtraInputs = ["Zeplin", "Z€pl1n"];
const MIN_PASSWORD_STRENGTH = 2;
const MIN_LENGTH_FOR_USER_INPUTS = 4;

type PasswordStrengthAnalysisResult = {
    weak: boolean;
    warning: string;
};

export default function analyzePasswordStrength(
    password: string,
    userInputs: string[] = []
): PasswordStrengthAnalysisResult {
    const passwordToAnalyze = password.length > PASSWORD_STRENGTH_CHECKER_THRESHOLD
        ? password.substring(0, PASSWORD_STRENGTH_CHECKER_THRESHOLD)
        : password;

    const result = zxcvbn(
        passwordToAnalyze,
        [...passwordStrengthExtraInputs, ...userInputs.filter(input => input.length >= MIN_LENGTH_FOR_USER_INPUTS)]
    );

    const {
        score,
        feedback: {
            warning: givenWarning
        },
        sequence
    } = result;

    const weak = score < MIN_PASSWORD_STRENGTH;

    const foundUserInputInPassword = sequence && sequence.some(item => item.dictionary_name === "user_inputs");

    let warning = givenWarning as string;
    if (foundUserInputInPassword) {
        warning = "Avoid having your username or email address in your password";
    }

    if (weak && !warning) {
        warning = "Avoid having common names and patterns in your password";
    }

    return {
        weak,
        warning
    };
}
